<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="title"
  (nzOnCancel)="handleClose()"
  [nzFooter]="null"
  [nzWidth]="'90vw'"
  [nzBodyStyle]="{ height: '80vh', padding: '0', overflow: 'hidden' }"
  nzCentered
  [nzClosable]="false"
  [nzMaskClosable]="true"
  nzClassName="image-viewer-modal"
  [testId]="'image-viewer-modal'"
>
  <ng-container *nzModalContent>
    <div class="image-viewer-container" [testId]="'image-viewer-container'">
      <!-- 工具列 -->
      <div class="image-toolbar" *ngIf="showToolbar" [testId]="'image-viewer-toolbar'">
        <div class="toolbar-left" [testId]="'image-viewer-toolbar-left'">
          <span class="image-info" [testId]="'image-viewer-scale-info'">{{ getScalePercentage() }}%</span>
        </div>

        <div class="toolbar-center" [testId]="'image-viewer-toolbar-center'">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="zoomOut()"
            [disabled]="scale <= minScale"
            [nz-tooltip]="'avatar.viewer.zoom-out' | i18n"
            [testId]="'image-viewer-zoom-out-button'"
          >
            <nz-icon nzType="zoom-out" nzTheme="outline" [testId]="'image-viewer-zoom-out-icon'" />
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="actualSize()"
            [nz-tooltip]="'avatar.viewer.actual-size' | i18n"
            [testId]="'image-viewer-actual-size-button'"
          >
            <nz-icon nzType="border-outer" nzTheme="outline" [testId]="'image-viewer-actual-size-icon'" />
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="zoomIn()"
            [disabled]="scale >= maxScale"
            [nz-tooltip]="'avatar.viewer.zoom-in' | i18n"
            [testId]="'image-viewer-zoom-in-button'"
          >
            <nz-icon nzType="zoom-in" nzTheme="outline" [testId]="'image-viewer-zoom-in-icon'" />
          </button>

          <nz-divider nzType="vertical" [testId]="'image-viewer-divider-1'" />

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="rotateLeft()"
            [nz-tooltip]="'avatar.viewer.rotate-left' | i18n"
            *ngIf="showRotate"
            [testId]="'image-viewer-rotate-left-button'"
          >
            <nz-icon nzType="rotate-left" nzTheme="outline" [testId]="'image-viewer-rotate-left-icon'" />
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="rotateRight()"
            [nz-tooltip]="'avatar.viewer.rotate-right' | i18n"
            *ngIf="showRotate"
            [testId]="'image-viewer-rotate-right-button'"
          >
            <nz-icon nzType="rotate-right" nzTheme="outline" [testId]="'image-viewer-rotate-right-icon'" />
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="resetTransform()"
            [nz-tooltip]="'avatar.viewer.reset' | i18n"
            [testId]="'image-viewer-reset-button'"
          >
            <nz-icon nzType="reload" nzTheme="outline" [testId]="'image-viewer-reset-icon'" />
          </button>

          <nz-divider nzType="vertical" *ngIf="showDownload || showFullscreen" [testId]="'image-viewer-divider-2'" />

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="downloadImage()"
            [nz-tooltip]="'avatar.viewer.download' | i18n"
            *ngIf="showDownload"
            [testId]="'image-viewer-download-button'"
          >
            <nz-icon nzType="download" nzTheme="outline" [testId]="'image-viewer-download-icon'" />
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="toggleFullscreen()"
            [nz-tooltip]="'avatar.viewer.fullscreen' | i18n"
            *ngIf="showFullscreen"
            [testId]="'image-viewer-fullscreen-button'"
          >
            <nz-icon
              [nzType]="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
              nzTheme="outline"
              [testId]="'image-viewer-fullscreen-icon'"
            />
          </button>
        </div>

        <div class="toolbar-right" [testId]="'image-viewer-toolbar-right'">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="handleClose()"
            [nz-tooltip]="'avatar.viewer.close' | i18n"
            [testId]="'image-viewer-close-button'"
          >
            <nz-icon nzType="close" nzTheme="outline" [testId]="'image-viewer-close-icon'" />
          </button>
        </div>
      </div>

      <!-- 圖片顯示區域 -->
      <div class="image-display-area" (wheel)="onWheel($event)" (mousedown)="onMouseDown($event)" [testId]="'image-viewer-display-area'">
        <div class="image-wrapper" [testId]="'image-viewer-wrapper'">
          <img
            [src]="imageUrl"
            [style.transform]="getImageTransform()"
            [style.cursor]="isDragging ? 'grabbing' : 'grab'"
            class="viewer-image"
            draggable="false"
            [alt]="'avatar.viewer.preview-image' | i18n"
            [testId]="'image-viewer-image'"
          />
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
